import axios from 'axios';
import { API_BASE_URL } from '../../../utils/configure-environment';
import { SHOP_LOCALE } from '../../../utils/configure-environment';

export default axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept-Language': SHOP_LOCALE
  }
});
